export * from '../../../../node_modules/tslib/tslib.js';

export * as tslib from '../../../../node_modules/tslib/tslib.js';